import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const LoadingPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${props => props.theme.colors.white};
  position: relative;
`;

export const SpinnerContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid ${props => `${props.theme.colors.porterPrimary}33`};
  border-top-color: ${props => props.theme.colors.porterPrimary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 24px;
`;

export const PoweredByText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${props => props.theme.colors.highBlack};
  text-transform: lowercase;
  opacity: 0.8;
`;
